import {
  CUSTOM_DATE_FILTER_TABLE_TYPE,
  CUSTOM_SELECT_FILTER_TABLE_TYPE,
} from "constants/RemoteDataTableContanst";
import PropTypes from "prop-types";
import React, { useEffect, useState } from "react";
import BootstrapTable from "react-bootstrap-table-next";
import filterFactory from "react-bootstrap-table2-filter";
import overlayFactory from "react-bootstrap-table2-overlay";
import paginationFactory, {
  PaginationListStandalone,
  PaginationProvider,
  SizePerPageDropdownStandalone,
} from "react-bootstrap-table2-paginator";
import ToolkitProvider from "react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit";
import { useTranslation } from "react-i18next";
import {
  Col,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  Row,
  UncontrolledDropdown,
  UncontrolledTooltip,
} from "reactstrap";
import { actionAccess } from "../../../constants/actionAccess";
import SearchTable from "../RemoteTable/search-table";

const RemoteDataTable = props => {
  const {
    keyField,
    data,
    columns,
    page,
    sizePerPage,
    totalSize,
    onTableChange,
    rowEvents,
    selectRow,
    listRowAction,
    listMultipleRowAction,
    onSearchAllHandle,
    optionShowColumnHandel,
    children,
    loading,
    onRowsSelect,
    expandRow,
    isShowSearchAll,
    isShowPagination,
    isShowSearchIndex,
    isShowRowIndex,
    searchSticky,
    customSearchComponent,
    sizePerPageListAppend = [],
    classNameTable = "custom-remote-table",
  } = props;

  useEffect(() => {
    // reset row select when data change
    setValueSelected([]);
    setRowsSelected([]);
  }, [data, loading]);

  const { t, i18n } = useTranslation("common");
  const [valueSelected, setValueSelected] = useState([]);
  const [rowsSelected, setRowsSelected] = useState([]);

  // Init custom column
  const initColumn = () => {
    // Col rowIndex
    const rowIndexColumn = {
      dataField: "rowIndex",
      text: t("index"),
      hidden: columns.length === 0 ? false : !isShowRowIndex,
      align: "center",
      headerStyle: (colum, colIndex) => {
        return { width: "80px", textAlign: "center" };
      },
      formatter: (cellContent, row, enumObject) => (
        <span>{(page - 1) * sizePerPage + enumObject + 1}</span>
      ),
    };

    // Default columns
    const initColumn = [rowIndexColumn, ...columns];
    if (listRowAction?.length > 0) {
      const columnAction = {
        dataField:
          props.isAuditLogsPage ||
            props.isCustomerAuditLogsTable ||
            props.isTransportLocalitiesAuditLogsTable
            ? "action_audit"
            : "action",
        text: t("action"),
        isDummyField: true,
        formatter: (cellContent, row, enumObject) =>
          generateAction(row, enumObject),
      };
      initColumn.push(columnAction);
    }
    return initColumn;
  };

  /* If > maxAction thì thành button ... */
  const maxAction = 3;
  const generateAction = (row, rowIndex) => {
    // Filter conditionVisible of action if have
    const listActionFinal = listRowAction.filter(item => {
      if (item?.isShow === false) {
        return false;
      }
      let isShow = true;
      // Normal action condition
      const conditionVisible = item?.conditionVisible;
      const isShowResults = [];
      for (const key in conditionVisible) {
        const k = key.split(".");
        let lastValue = row;
        for (const item of k) {
          lastValue =
            lastValue?.[item] !== undefined && lastValue !== null
              ? lastValue[item]
              : null;
        }

        let currentKeyIsShow = true;
        if (conditionVisible[key].length === 0) {
          currentKeyIsShow = lastValue ? true : false;
        } else {
          if (
            lastValue !== undefined &&
            lastValue !== null &&
            conditionVisible[key].findIndex(c => c === lastValue) === -1
          ) {
            currentKeyIsShow = false;
          }
        }
        isShowResults.push(currentKeyIsShow);
      }

      // isShow cuối cùng chỉ true khi tất cả các điều kiện đều true
      isShow =
        isShowResults.length > 0
          ? isShowResults.every(result => result === true)
          : true;
      // WorkFlows action condition
      const workflowAction = row.workflowAction;
      if (item.actionCode && isShow) {
        isShow = false;
        if (workflowAction !== null && workflowAction.actions?.length) {
          isShow =
            workflowAction.actions.findIndex(
              action => action.code === item.actionCode
            ) !== -1
              ? true
              : false;
        }
      }
      return isShow;
    });
    const listActionOut = listActionFinal.slice(0, maxAction);
    const listActionMore = listActionFinal.slice(maxAction);
    return (
      <div
        className="d-flex gap-2 align-items-center justify-content-center"
        style={{ lineHeight: "14px" }}
      >
        {listActionOut.map((action, index) => {
          return (
            <React.Fragment key={index}>
              {/* Button more actions */}
              {index === 0 && listActionMore.length > 0 && (
                <UncontrolledDropdown direction="left" className="text-center">
                  <DropdownToggle
                    id={`${classNameTable}-actionMore-` + index + rowIndex}
                    href="#"
                    disabled={loading}
                    style={{ cursor: loading ? "not-allowed" : "pointer" }}
                    className="card-drop"
                    tag="i"
                  >
                    <i className="mdi mdi-dots-vertical font-size-18" />
                  </DropdownToggle>
                  <UncontrolledTooltip
                    placement="top"
                    target={`${classNameTable}-actionMore-` + index + rowIndex}
                  >
                    {t("moreAction")}
                  </UncontrolledTooltip>
                  <DropdownMenu
                    className="dropdown-menu-end"
                    style={{ zIndex: 5, border: " 1px solid #808080d4" }}
                  >
                    {listActionMore.map((actionMore, indexMore) => {
                      return (
                        <DropdownItem
                          href="#"
                          key={indexMore}
                          className="d-flex gap-3 align-items-center"
                          onClick={() => {
                            actionMore.onClick &&
                              actionMore.onClick(row, rowIndex);
                          }}
                          onMouseDown={e => {
                            if (action.onRightClick) {
                              e.preventDefault();
                              action.onRightClick(row, rowIndex, e);
                            }
                          }}
                        >
                          {actionMore.icon}
                          {actionMore.text}
                        </DropdownItem>
                      );
                    })}
                  </DropdownMenu>
                </UncontrolledDropdown>
              )}
              {action &&
                action.actionAccess ===
                actionAccess.GLOG_FUNCTION_NOTIFICATION_VIEW ? (
                <a
                  href={row.linkRef}
                  id={`${classNameTable}-action-` + index + rowIndex}
                  style={{
                    cursor: loading ? "not-allowed" : "pointer",
                  }}
                  onClick={event => {
                    event.stopPropagation();
                    if (loading) return;
                    action.onClick && action.onClick(row, rowIndex);
                  }}
                  onMouseDown={e => {
                    if (action.onRightClick) {
                      e.preventDefault();
                      action.onRightClick(row, rowIndex, e);
                    }
                  }}
                >
                  {action.icon}
                  <UncontrolledTooltip
                    placement="top"
                    target={`${classNameTable}-action-` + index + rowIndex}
                  >
                    {action.text}
                  </UncontrolledTooltip>
                </a>
              ) : (
                <div
                  id={`${classNameTable}-action-` + index + rowIndex}
                  style={{
                    cursor: loading ? "not-allowed" : "pointer",
                  }}
                  onClick={event => {
                    event.stopPropagation();
                    if (loading) return;
                    action.onClick && action.onClick(row, rowIndex);
                  }}
                  onMouseDown={e => {
                    if (action.onRightClick) {
                      e.preventDefault();
                      action.onRightClick(row, rowIndex, e);
                    }
                  }}
                >
                  {action.icon}
                  <UncontrolledTooltip
                    placement="top"
                    target={`${classNameTable}-action-` + index + rowIndex}
                  >
                    {action.text}
                  </UncontrolledTooltip>
                </div>
              )}
            </React.Fragment>
          );
        })}
      </div>
    );
    // }
  };

  const FILTER_DATE_COMPARATOR = {
    "~": "~",
    "=": "eq",
    "!=": "neq",
    ">": "gt",
    ">=": "gte",
    "<": "lt",
    "<=": "lte",
  };

  // Format data
  const formatDataTable = (
    type,
    { page, sizePerPage, sortField, sortOrder, filters }
  ) => {
    sortOrder = sortOrder === "desc" ? "-" : "";
    // Filter
    const columnFilter = {};
    const tempFilters = Object.assign({}, filters);
    for (let key in filters) {
      if (key.includes("notification.")) {
        const list = key.split(".");
        if (list.length == 2) {
          tempFilters[list[1]] = tempFilters[key];
          delete tempFilters[key];
          key = list[1];
        }
      }
      const filterType = tempFilters[key].filterType;
      const filterVal = tempFilters[key].filterVal;
      switch (filterType) {
        case "SELECT":
          columnFilter[`filter[${key}]`] = filterVal;
          break;
        case "TEXT":
          if (key === "delay_time") {
            const delayTimeValue = String(filterVal ?? "")
              .replace(/[^\d]/g, "")
              .trim();
            if (delayTimeValue !== "") {
              columnFilter.delay_time = delayTimeValue;
            }
          } else {
            columnFilter[`filter[${key}][like]`] = filterVal;
          }
          break;
        case CUSTOM_DATE_FILTER_TABLE_TYPE:
          if (filterVal.date && filterVal.date.length > 0) {
            let dateCustom = [];
            for (const filterDate of filterVal.date) {
              const offset = filterDate.getTimezoneOffset();
              const date = new Date(filterDate.getTime() - offset * 60 * 1000);
              dateCustom.push(date.toISOString().split("T")[0]);
            }
            const comparatorCustom =
              FILTER_DATE_COMPARATOR[filterVal.comparator];
            if (dateCustom && comparatorCustom) {
              if (dateCustom.length > 1) {
                columnFilter[`filter[${key}][gte]`] = dateCustom[0];
                columnFilter[`filter[${key}][lte]`] = dateCustom[1];
              } else {
                const date = dateCustom[0];
                columnFilter[`filter[${key}][${comparatorCustom}]`] = date;
              }
            }
          }
          break;
        case "DATE":
          const date = filterVal.date;
          const comparator = FILTER_DATE_COMPARATOR[filterVal.comparator];
          if (date && comparator) {
            columnFilter[`filter[${key}][${comparator}]`] = date
              .toISOString()
              .split("T")[0];
          }
          break;
        case CUSTOM_SELECT_FILTER_TABLE_TYPE:
          if (filterVal.data && filterVal.data.value) {
            columnFilter[`filter[${key}]`] = filterVal.data.value;
          }
          break;
        default:
          break;
      }
    }
    //

    onTableChange(type, {
      page,
      sizePerPage,
      sortField,
      sortOrder,
      columnFilter,
    });
  };

  const MODE_CHECKBOX = "checkbox";
  const MODE_RADIO = "radio";

  /* START custom row select (checkbox / radio ...)  */
  const handleOnSelect = (row, isSelect) => {
    let data = [];
    let rows = [];

    if (selectRowCustom.mode === MODE_CHECKBOX) {
      if (isSelect) {
        data = [...valueSelected, row[keyField]];
        rows = [...rowsSelected, row];
      } else {
        data = valueSelected.filter(x => x !== row[keyField]);
        rows = rowsSelected.filter(x => x?.id !== row[keyField]);
      }
    } else if (selectRowCustom.mode === MODE_RADIO) {
      data = [row[keyField]];
      rows = [row];
    }
    setValueSelected(data);
    setRowsSelected(rows);
    onRowsSelect && onRowsSelect(data, rows);
  };

  const handleOnSelectAll = (isSelect, rows) => {
    const ids = rows.map(r => r[keyField]);
    let data = [];
    let rowsData = [];
    if (isSelect) {
      data = ids;
      rowsData = rows;
    }
    setValueSelected(data);
    setRowsSelected(rowsData);
    onRowsSelect && onRowsSelect(data, rowsData);
  };

  const selectRowCustom = {
    clickToSelect: false,
    selected: valueSelected,
    ...selectRow,
    onSelect: handleOnSelect,
    onSelectAll: handleOnSelectAll,
  };
  /* END custom row select (checkbox / radio ...)  */

  /* START custom noData  */
  const defaultEmptyDataMessage = () => {
    return <div className="text-center">{t("table_empty")}</div>;
  };
  /* END custom noData  */

  const rowStyle = (row, rowIndex) => {
    return {
      backgroundColor: row.is_receive_bus_cost_value_mismatch
        ? "#FFFEEF"
        : row.isHightLight
          ? "#f8d7da"
          : "white",
    };
  };

  return (
    <PaginationProvider
      pagination={paginationFactory({
        page,
        sizePerPage,
        totalSize,
        custom: true,
        sizePerPageList: [
          {
            text: "10",
            value: 10,
          },
          {
            text: "25",
            value: 25,
          },
          {
            text: "35",
            value: 35,
          },
          {
            text: "50", // max from api
            value: 50,
          },
          ...sizePerPageListAppend,
        ],
      })}
    >
      {({ paginationProps, paginationTableProps }) => (
        <ToolkitProvider
          keyField={keyField}
          columns={initColumn()}
          data={data}
          columnToggle
        >
          {toolkitProps => (
            <React.Fragment>
              {isShowSearchAll && (
                <SearchTable
                  loading={loading}
                  optionShowColumnHandel={optionShowColumnHandel}
                  onSearchAllHandle={onSearchAllHandle}
                  columnToggleProps={toolkitProps.columnToggleProps}
                  rowSelected={valueSelected}
                  listMultipleRowAction={listMultipleRowAction}
                  isShowSearchIndex={isShowSearchIndex}
                  sticky={searchSticky}
                >
                  {children}
                </SearchTable>
              )}
              {customSearchComponent && <Row>{customSearchComponent}</Row>}
              <Row className="mt-4">
                <Col xl="12">
                  <div className={`table-responsive ${classNameTable}`}>
                    <BootstrapTable
                      rowStyle={rowStyle}
                      remote
                      filter={filterFactory()}
                      wrapperClasses={
                        listRowAction?.length > 0 ? "table-col-action" : ""
                      }
                      responsive
                      selectRow={selectRow ? selectRowCustom : undefined}
                      expandRow={expandRow ? expandRow : undefined}
                      hover={true}
                      rowEvents={rowEvents}
                      loading={loading}
                      onTableChange={formatDataTable}
                      overlay={overlayFactory({
                        spinner: true,
                        styles: {
                          overlay: base => ({
                            ...base,
                            "z-index": 2,
                            background: "#e9ecef",
                          }),
                        },
                      })}
                      noDataIndication={defaultEmptyDataMessage}
                      bordered={true}
                      // striped={true}
                      classes={"table align-middle table-nowrap"}
                      {...toolkitProps.baseProps}
                      {...paginationTableProps}
                    />
                  </div>
                </Col>
              </Row>
              {isShowPagination && (
                <Row
                  className="align-items-md-center mt-30"
                  style={{ marginTop: "5px" }}
                >
                  <Col className="inner-custom-pagination d-flex">
                    <div className="d-inline">
                      <SizePerPageDropdownStandalone {...paginationProps} />
                    </div>
                    <div className="text-md-right ms-auto">
                      <PaginationListStandalone {...paginationProps} />
                    </div>
                  </Col>
                </Row>
              )}
            </React.Fragment>
          )}
        </ToolkitProvider>
      )}
    </PaginationProvider>
  );
};

RemoteDataTable.propTypes = {
  loading: PropTypes.bool,
  keyField: PropTypes.string.isRequired,
  data: PropTypes.array.isRequired,
  columns: PropTypes.array.isRequired,
  page: PropTypes.number,
  sizePerPage: PropTypes.number,
  totalSize: PropTypes.number,
  onTableChange: PropTypes.func.isRequired,
  rowEvents: PropTypes.object,
  columnToggleProps: PropTypes.any,
  children: PropTypes.any,
  onSearchAllHandle: PropTypes.func, // call back button tìm kiếm
  optionShowColumnHandel: PropTypes.func, // call back button ẩn hiện column
  listRowAction: PropTypes.array, // action từng dòng
  listMultipleRowAction: PropTypes.array, // action button tác vụ hàng loạt
  selectRow: PropTypes.object,
  onRowsSelect: PropTypes.func, // call back when select row (Checkbox / radio)
  expandRow: PropTypes.object,
  isShowSearchAll: PropTypes.bool,
  isShowPagination: PropTypes.bool,
  isShowSearchIndex: PropTypes.bool,
  isShowRowIndex: PropTypes.bool,
  searchSticky: PropTypes.bool,
  customSearchComponent: PropTypes.any,
  classNameTable: PropTypes.any,
  isAuditLogsPage: PropTypes.bool,
  isCustomerAuditLogsTable: PropTypes.bool,
  isTransportLocalitiesAuditLogsTable: PropTypes.bool,
};

RemoteDataTable.defaultProps = {
  isShowSearchAll: true,
  isShowPagination: true,
  isShowSearchIndex: true,
  isShowRowIndex: true,
  customSearchComponent: null,
  isAuditLogsPage: false,
  isCustomerAuditLogsTable: false,
  isTransportLocalitiesAuditLogsTable: false,
};

export default RemoteDataTable;
